import { Stack } from '@mui/material'
import {
    NameFilter,
    CompanyFilter,
    EmailFilter,
    PhoneFilter,
    SchoolFilter,
    ProcessStatusFilter,
} from 'client/candidate-table-temp/components/Filters'
import { type CandidateFilterState } from 'client/candidate-table-temp/hooks/useRosterSearchWithFilters'
import { useProcessStatusOptions } from 'client/candidate-table-temp/hooks/useProcessStatusOptions'

interface ClientRosterFiltersProps {
    filters: CandidateFilterState
    setFilters: (filters: CandidateFilterState) => void
}

export function ClientRosterFilters({
    filters,
    setFilters,
}: ClientRosterFiltersProps) {
    const { processStatusOptions } = useProcessStatusOptions()
    const handleFilterChange = (updates: Partial<CandidateFilterState>) => {
        setFilters({
            ...filters,
            ...updates,
        })
    }

    return (
        <Stack overflow="auto" flex={1} spacing={2} padding={2}>
            <NameFilter
                name={filters.name || ''}
                onChange={(value) =>
                    handleFilterChange({ name: value || undefined })
                }
            />

            <EmailFilter
                email={filters.email || ''}
                onChange={(value) =>
                    handleFilterChange({ email: value || undefined })
                }
            />

            <PhoneFilter
                phone={filters.phone || ''}
                onChange={(value) =>
                    handleFilterChange({ phone: value || undefined })
                }
            />

            <CompanyFilter
                companyIds={filters.companyIds}
                companyTimeFrame={filters.companyTimeFrame}
                companyDateRange={filters.companyDateRange}
                onChange={(filterUpdates) =>
                    handleFilterChange({
                        companyIds: filterUpdates.companyIds || [],
                        companyTimeFrame: filterUpdates.companyTimeFrame,
                        companyDateRange: filterUpdates.companyDateRange,
                    })
                }
            />

            <SchoolFilter
                collegeIds={filters.collegeIds}
                onChange={(ids) => handleFilterChange({ collegeIds: ids })}
            />

            <ProcessStatusFilter
                processStatus={filters.processStatus}
                processStatusOptions={processStatusOptions}
                onChange={(statuses) =>
                    handleFilterChange({ processStatus: statuses })
                }
            />
        </Stack>
    )
}
